import { UserGroup } from '../types/shared/db'

export const adminCollectionAccess: Array<UserGroup> = ['admin']
export const practiceCollectionAccess: Array<UserGroup> = ['admin', 'practice']
export const patientCollectionAccess: Array<UserGroup> = ['admin', 'practice', 'patient']
